import { imgs } from '../../assets/imgs'
import { tracking } from '../../utils/tracking'

export const Location = () => {
   return (
      <div className='location'>
         <section>
            <iframe
               title='venue-map'
               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2954.475459149433!2d-71.1696285!3d42.225654299999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89e37fe73d3f89d3%3A0xc8d483267fec5e27!2sHilton%20Boston%2FDedham!5e0!3m2!1sen!2sil!4v1693754458877!5m2!1sen!2sil"
               style={{ border: "0", width: "100%", height: "100%" }}
               allowFullScreen
               loading="lazy"
               referrerPolicy="no-referrer-when-downgrade"
            />
            {/* <img src={imgs.venue.venueLocation} alt="" /> */}
         </section>
         <section>
            <h1>Location & Directions</h1>
            <p>Hilton Boston/Dedham</p>
            <p>25 Allied Dr, Dedham, MA</p>
            <div className='icons'>
               <a rel='noreferrer' target="_blank" href="https://goo.gl/maps/rSnj4y7BVPw4i9Mt7"
                  onClick={() => tracking(295)}
               >
                  <img src={imgs.icons.googleMaps} alt="google-maps" />
               </a>
               <a
                  rel='noreferrer'
                  target="_blank"
                  href="https://ul.waze.com/ul?preview_venue_id=189268390.1892880510.1604553&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location"
                  onClick={() => tracking(296)}
               >
                  <img src={imgs.icons.waze} alt="waze" />
               </a>
            </div>
         </section>
      </div>
   )
}

